import axiosClient from './axiosClient';
import { unwrapApiResponse } from '../utils/unwrapApiResponse';

export const getPages = async () => {
  const response = await axiosClient.get('/api/admin/pages');
  return unwrapApiResponse(response);
};

export const getPageById = async (id) => {
  const response = await axiosClient.get(`/api/admin/pages/${id}`);
  return unwrapApiResponse(response);
};

export const getPageBySlug = async (slug) => {
  const pages = await getPages();
  return pages.find((page) => page.slug === slug) || null;
};

export const createPage = async (payload) => {
  const response = await axiosClient.post('/api/admin/pages', payload);
  return unwrapApiResponse(response);
};

export const deletePage = async (pageId) => {
  const response = await axiosClient.delete(`/api/admin/pages/${pageId}`);
  return unwrapApiResponse(response);
};
